<template>
  <label class="flex cursor-pointer items-center gap-2.5">
    <input
      :checked="value"
      type="checkbox"
      class="accent-[#ffaa00]"
      @change="$emit('input', $event.target.checked)"
    />
    <span class="grid gap-1">
      <span class="text-xs font-semibold text-[#dde6f3]">{{ label }}</span>
      <span v-if="hint" class="text-xs text-[#91a0b4]">{{ hint }}</span>
    </span>
  </label>
</template>

<script>
export default {
  name: "NativeCheckboxField",
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    label: {
      type: String,
      required: true,
    },
    hint: {
      type: String,
      default: "",
    },
  },
};
</script>
